/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Changelog_Seo_DescriptionInputs */

const en_marketing_changelog_seo_description = /** @type {(inputs: Marketing_Changelog_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every Onyx release: what shipped and when. The foundation improves continuously.`)
};

const es_marketing_changelog_seo_description = /** @type {(inputs: Marketing_Changelog_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada versión de Onyx: qué se lanzó y cuándo. La base mejora continuamente.`)
};

const fr_marketing_changelog_seo_description = /** @type {(inputs: Marketing_Changelog_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque version d'Onyx : ce qui a été livré et quand. La fondation s'améliore en continu.`)
};

/**
* | output |
* | --- |
* | "Every Onyx release: what shipped and when. The foundation improves continuously." |
*
* @param {Marketing_Changelog_Seo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_changelog_seo_description = /** @type {((inputs?: Marketing_Changelog_Seo_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Changelog_Seo_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_changelog_seo_description(inputs)
	if (locale === "es") return es_marketing_changelog_seo_description(inputs)
	return fr_marketing_changelog_seo_description(inputs)
});